import React, { useState, useEffect } from 'react';
import { adminApi } from '../api/adminApi';
import toast, { Toaster } from 'react-hot-toast';
import PremiumTable from '../components/common/PremiumTable';

const Products = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const res = await adminApi.getAllProducts();
      setProducts(res.data.data);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to load products');
    } finally {
      setLoading(false);
    }
  };

  const statusBadge = (isActive) => {
    return isActive 
      ? <span className="px-3 py-1 inline-flex text-xs font-bold rounded-full bg-green-100 text-green-800 border border-green-200">Active</span>
      : <span className="px-3 py-1 inline-flex text-xs font-bold rounded-full bg-gray-100 text-gray-800 border border-gray-200">Archived</span>;
  };

  const columns = [
    {
      header: 'Product Name',
      accessor: 'name',
      render: (row) => (
        <span className="text-sm font-bold text-gray-900">{row.name}</span>
      )
    },
    {
      header: 'Business',
      accessor: 'businessId.name',
      render: (row) => (
        <span className="text-sm text-gray-900">{row.businessId?.name || 'Unknown'}</span>
      )
    },
    {
      header: 'Price / Stock',
      accessor: 'price',
      render: (row) => (
        <div>
          <div className="text-sm font-medium text-gray-900">₹{row.price}</div>
          <div className="text-xs text-gray-500">Stock: {row.stock}</div>
        </div>
      )
    },
    {
      header: 'SKU / Category',
      accessor: 'sku',
      render: (row) => (
        <div>
          <div className="text-sm text-gray-500">{row.sku || 'N/A'}</div>
          <div className="text-xs text-gray-500">{row.category || 'N/A'}</div>
        </div>
      )
    },
    {
      header: 'Status',
      accessor: 'isActive',
      render: (row) => statusBadge(row.isActive)
    }
  ];

  return (
    <div className="min-h-screen bg-transparent pb-12">
      <Toaster position="top-right" />
      
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        {loading ? (
          <div className="p-12 text-center text-gray-500">Loading products...</div>
        ) : (
          <PremiumTable 
            title="Global Inventory Monitor"
            data={products}
            columns={columns}
            searchKeys={['name', 'businessId.name', 'sku', 'category']}
            primaryKey="_id"
            paginationMode="standard"
            itemsPerPage={10}
          />
        )}
      </main>
    </div>
  );
};

export default Products;
